import * as Html from "../../util/Html.ts";
import * as Redim from "../../lib/redim/imageRedim.js";
import * as Medias from "../../server/Medias.js";
import * as actionMenuRegistry from "../action-menu-registry.ts";
import * as actionMenu from "../action-menu.js";
import Icons from "../../svg/Icons.ts";
import ApiServer from "../../ApiServer.js";
import * as FwDatas from "../../FwDatas.ts";
import {pickFile} from "../../filer/filerModal.ts";
import {pickFileFromDevice} from "../../lib/FileUtils.ts"

export {init,destroy}
Html.registerWidget('widget/form/input-file-menu',{init:init})


actionMenuRegistry.register({
  pickfilemenu(){
    var 
      node = this,
      inputFile = node.find('input').get(0),
      menu = [];

    inputFile.customFiles = [];
      
    menu.push({svg:Icons.ic_gallery, async clickFunction(){
      var files = await pickFileFromDevice('image/*');
      if(files.length){
        inputFile.customFiles = files;
        inputFile.medias = undefined;
      }
      inputFile.dispatchEvent(new Event("change"));
    },i18nkey:'actions.addpicture'});
    
    if(FwDatas.getPermission('filer')==='OK'){

      menu.push({svg:Icons.ic_add_file, async clickFunction(){
        var files = await pickFileFromDevice('*/*');
        if(files.length){
          inputFile.customFiles = files;
          inputFile.medias = undefined;
        }
        inputFile.dispatchEvent(new Event("change"));
      },i18nkey:'actions.attachfile'})

      menu.push({svg:Icons.ic_insert_file, async clickFunction(){
        var media = await pickFile({title:'actions.attachfilefromfiler'});
        if(media){
          inputFile.medias = [media];
        }
        inputFile.dispatchEvent(new Event("change"));
      },i18nkey:'actions.attachfilefromfiler'})

    }else if(FwDatas.getPermission('filer')==='KO_PREMIUM'){

      menu.push({svg:Icons.ic_add_file, onclick:'takepremium', i18nkey:'actions.attachfile', svgend:Icons.ic_premium_feature_indicator})

      menu.push({svg:Icons.ic_insert_file, onclick:'takepremium', i18nkey:'actions.attachfilefromfiler', svgend:Icons.ic_premium_feature_indicator})

    }  
    return {menu}  
  }
})

function init(node){
  node.attr('data-key','pickfilemenu')
  actionMenu.init(node)
  var 
    inputFile = node.find('input'),
    imgTag = node.find('img'),
    icon = node.find('icon'),
    isSmall = node.width()<80,
    nocontroll = node.attr("data-ui")==="nocontroll";
  
  node.addClass("input-image");
  
  if(!inputFile.prop('disabled') && !nocontroll){
    const commonStyle = isSmall?"padding:2px;width:16px;height:16px;line-height:16px;top:-6px;right:-6px":"zoom:85%;";
    node.append('<ib class="picture-delete" style="'+commonStyle+'">'+Icons.ic_close+'</ib>');
    node.append('<ib class="picture-reset"  style="'+commonStyle+'">'+Icons.ic_repeat+'</ib>');
  }
  var 
    deleteTag = node.find('.picture-delete'),
    resetTag = node.find('.picture-reset'),
    originalValue = node.attr("data-value")||inputFile.attr("data-value"),
    deletedValue = node.attr("data-default"),
    value = originalValue;
  
  
  function setPreview(thumb){
    value = thumb;
    if(isSmall){
      icon.toggle(thumb===null)
    }
    if(nocontroll){
      if(value){
        node.find('.input-controll').css("visibility","hidden");
      }else{
        node.find('.input-controll').css("visibility","visible");
      }
    }
    if(imgTag.length){
      if(value || deletedValue){
        imgTag.attr("src",value || deletedValue);
        imgTag.css("visibility","visible");
      }else{
        imgTag.css("visibility","hidden");
      }
    }else{
      if(value || deletedValue){
        node.css("background-position","50%");
        node.css("background-size","cover");
        node.css("background-image","url('"+(value || deletedValue)+"')");
      }else{
        node.css("background-image",'unset');
      }
    }
    
    deleteTag.toggle(value!==null);
    resetTag.toggle(value===null && !!originalValue);
    //IMPORTANT it is read by SRV to dectect that $empty should be sent
    inputFile.prop("empty",value===null);
  }
  setPreview(value||null);
  
  deleteTag.on("click",function(e){
    e.stopPropagation();
    e.preventDefault();
    inputFile.get(0).medias = undefined;
    inputFile.get(0).customFiles = [];
    inputFile.val('').trigger('change');
  });
  resetTag.on("click",function(e){
    e.stopPropagation();
    e.preventDefault();
    inputFile.get(0).medias = undefined;
    setPreview(originalValue);
  });
  inputFile.on('change',async function(){
    if(!await Medias.checkQuota()) return;
    var 
      file = this.customFiles[0],
      medias = this.medias;
    
    if(medias!==undefined){
      setPreview(medias[0].icon.toURL())
      return;
    }else if(!file){
      setPreview(null);
      return;
    }
    if(file.type.indexOf('image/')===0){
      Redim.thumbnail(file,{width:node.width(),height:node.height()},setPreview,setPreview)
    }else{
      setPreview(ApiServer.types.IMedia.prototype.getIconFromMimeType(file.type).toURL())
    }
  });
}

function destroy(node){
  actionMenu.destroy(node);
}
 